import { ForgetPassword } from "../pages/Auth/ForgetPassword";
import { Login } from "../pages/Auth/Login";
import { Register } from "../pages/Auth/Register";
import { MultifactorAuth } from "../pages/Auth/MultifactorAuth";
import { ResetPassword } from "../pages/Auth/ResetPassword";
import { CreatePassword } from "../pages/Auth/CreatePassword";
import { SignUp } from "../pages/Auth/SignUp";
import { VerifyEmail } from "../pages/Auth/VerifyEmail";

const basePath = process.env.REACT_APP_BASE_URL;

/**
 * Public Routes Available in App
 * @type {{}}
 */
export const publicRoutes = [
  {
    path: `${basePath}/`, element: <Login />
  },
  {
    path: `${basePath}/login`, element: <Login />
  },
  {
    path: `${basePath}/register`, element: <Register />
  },
  {
    path: `${basePath}/verification`, element: <MultifactorAuth />
  },
  {
    path: `${basePath}/forgot-password`, element: <ForgetPassword />
  },
  {
    path: `${basePath}/reset-password/:token?`, element: <ResetPassword />
  },
  {
    path: `${basePath}/create-password/:token?`, element: <CreatePassword />
  },
  
  {
    path: `${basePath}/sign-up`, element: <SignUp />
  },
  {
    path: `${basePath}/verify-email/:token?`, element: <VerifyEmail />
  }
];

// Named Routes
export const nameBasedRoutes = {
  home: {
    name: "Home",
    path: `${basePath}`,
  },
  login: {
    name: "Login",
    path: `${basePath}/login`,
  },
  forgotPassword: {
    name: "Forgot Passowrd",
    path: `${basePath}/forgot-password`,
  },
  register: {
    name: "Register User",
    path: `${basePath}/register`,
  },

  changePassword: {
    name: "Change Password",
    path: `${basePath}/change-password`,
  }
  
};
